// Lightweight flag used to distinguish user-initiated sign-outs from automatic
// sign-outs (e.g. expired or invalidated refresh token).
//
// Usage:
//   1. Call markExplicitSignOut() immediately before supabase.auth.signOut()
//      in any UI-driven sign-out path.
//   2. Call consumeExplicitSignOut() inside onAuthStateChange when handling
//      the SIGNED_OUT event. It returns true if the sign-out was intentional
//      and resets the flag automatically.

let _explicitSignOut = false;

/** Mark the upcoming sign-out as user/app-initiated (not a session expiry). */
export const markExplicitSignOut = (): void => {
  _explicitSignOut = true;
};

/**
 * Read and immediately clear the explicit-sign-out flag.
 * Returns true if the sign-out was intentional, false if it was automatic
 * (e.g. Supabase invalidated the refresh token in the background).
 */
export const consumeExplicitSignOut = (): boolean => {
  const was = _explicitSignOut;
  _explicitSignOut = false;
  return was;
};
